import { ApplicationStage } from '../../../api/types';
import ListPageInner from '../../shared/ApplicationListPage/ListPageInner';

const ApplicationListPage = () => {
    const stage = ApplicationStage.Financing;
    const namespace = 'applicationList';

    return <ListPageInner namespace={namespace} stage={stage} />;
};

export default ApplicationListPage;
